/* Defines the horizontal padding in individual data columns */
export var getDataColumnPadding = size => {
  if (size === 'small') {
    return '0 3px';
  }
  if (size === 'large') {
    return '0 12px';
  }
  return '0 6px';
};

/* Defines the padding inside name, dataColumns, and action columns */
export var getRowColumnPadding = size => {
  if (size === 'small') {
    return '9px';
  }
  if (size === 'large') {
    return '18px';
  }
  return '12px';
};

/* Defines custom image size */
export var getCustomImageSize = size => {
  if (size === 'small') {
    return '42px';
  }
  if (size === 'large') {
    return '54px';
  }
  return '48px';
};

/* Sub-items are indented 12px more than parents */
export var getSubItemIndent = size => {
  if (size === 'small') return '51px';
  if (size === 'large') return '60px';
  return '54px';
};

/* Defines font attributes for lighter gray text in table */
export var getTableItemDescriptionSize = size => {
  if (size === 'small') {
    return 'var(--body-text-x-small)';
  }
  if (size === 'large') {
    return 'var(--body-text-medium)';
  }
  return 'var(--body-text-small)';
};

/* Defines padding on high-level table elements */
export var getTablePadding = size => {
  var vertical = 5;
  var horizontal = 6;
  if (size === 'small') {
    vertical = 4;
    horizontal = 5;
  }
  if (size === 'large') {
    vertical = 6;
    horizontal = 7;
  }
  return {
    vertical: "var(--spacing-".concat(vertical, ")"),
    horizontal: "var(--spacing-".concat(horizontal, ")")
  };
};